import { render, staticRenderFns } from "./DateElement.vue?vue&type=template&id=b9db52da&scoped=true&"
import script from "./DateElement.vue?vue&type=script&lang=js&"
export * from "./DateElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db52da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9db52da')) {
      api.createRecord('b9db52da', component.options)
    } else {
      api.reload('b9db52da', component.options)
    }
    module.hot.accept("./DateElement.vue?vue&type=template&id=b9db52da&scoped=true&", function () {
      api.rerender('b9db52da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/DateElement.vue"
export default component.exports